import React from 'react';
import BaseComponent from '../BaseComponent';
import PropTypes from 'prop-types';
import GF from "../../utils/GF";
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";

class DialogBase extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      title: GF.getValue(this.props.title), className: GF.getValue(this.props.className, '')
    };
  }

  closeDialog = (e, reason) => {
    if (reason === "backdropClick") return; // ignores clicks outside of input dialog
    if (this.props.onCloseButtonClick) {
      this.props.onCloseButtonClick(e);
    }
  }

  render() {
    let {children, scroll, maxWidth, open = true, fullWith = false} = this.props;
    return (<Dialog
      open={open}
      maxWidth={maxWidth}
      scroll={scroll}
      fullWidth={fullWith}
      onClose={(event, reason) => this.closeDialog(event, reason)}>
      <DialogTitle>
        <Box className='flex justify-between gap-5'>
          {this.props.title}
          {this.props.onCloseButtonClick && <IconButton size='small' onClick={this.closeDialog}><Close/></IconButton>}
        </Box>
      </DialogTitle>
      <DialogContent dividers={true}>
        {children}
      </DialogContent>
      {this.props.actions && <DialogActions>{this.props.actions}</DialogActions>}
    </Dialog>);
  }
}

DialogBase.propTypes = {
  title: PropTypes.string,
  scroll: PropTypes.oneOf(['paper', 'scroll']),
  open: PropTypes.bool,
  onCloseButtonClick: PropTypes.func,
  actions: PropTypes.node,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  fullWidth: PropTypes.bool,
};

export default DialogBase;
